import _objectSpread2 from "@babel/runtime/helpers/objectSpread";
import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { COLA_STATUS } from './colaEnums';

function getLatestLoan(_x, _x2) {
  return _getLatestLoan.apply(this, arguments);
}

function _getLatestLoan() {
  _getLatestLoan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(webapiUrl, headers) {
    var uri, overrideHeaders, res, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            uri = "".concat(webapiUrl, "/webapi/client/loans/latest");
            overrideHeaders = _typeof(headers[uri]) === 'object' ? headers[uri] : {};
            _context.next = 4;
            return fetch(uri, {
              method: 'GET',
              credentials: 'same-origin',
              headers: _objectSpread2({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, overrideHeaders)
            });

          case 4:
            res = _context.sent;

            if (!(res.status === 401)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", {
              status: COLA_STATUS.UNAUTHORISED
            });

          case 9:
            if (!(res.status !== 200)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", {
              status: COLA_STATUS.ERROR
            });

          case 11:
            _context.next = 13;
            return res.json();

          case 13:
            body = _context.sent;
            return _context.abrupt("return", {
              status: COLA_STATUS.OK,
              latestLoan: body
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getLatestLoan.apply(this, arguments);
}

function getClient(_x3, _x4) {
  return _getClient.apply(this, arguments);
}

function _getClient() {
  _getClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(webapiUrl, headers) {
    var uri, overrideHeaders, res, body;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            uri = "".concat(webapiUrl, "/webapi/client");
            overrideHeaders = _typeof(headers[uri]) === 'object' ? headers[uri] : {};
            _context2.next = 4;
            return fetch(uri, {
              method: 'GET',
              credentials: 'same-origin',
              headers: _objectSpread2({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, overrideHeaders)
            });

          case 4:
            res = _context2.sent;

            if (!(res.status === 401)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", {
              status: COLA_STATUS.UNAUTHORISED
            });

          case 9:
            if (!(res.status !== 200)) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", {
              status: COLA_STATUS.ERROR
            });

          case 11:
            _context2.next = 13;
            return res.json();

          case 13:
            body = _context2.sent;
            return _context2.abrupt("return", {
              status: COLA_STATUS.OK,
              client: body
            });

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getClient.apply(this, arguments);
}

function getClientApplication(_x5, _x6) {
  return _getClientApplication.apply(this, arguments);
}

function _getClientApplication() {
  _getClientApplication = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(webapiUrl, headers) {
    var uri, overrideHeaders, res, body;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            uri = "".concat(webapiUrl, "/webapi/client/application");
            overrideHeaders = _typeof(headers[uri]) === 'object' ? headers[uri] : {};
            _context3.next = 4;
            return fetch(uri, {
              method: 'GET',
              credentials: 'same-origin',
              headers: _objectSpread2({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, overrideHeaders)
            });

          case 4:
            res = _context3.sent;

            if (!(res.status === 401)) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt("return", {
              status: COLA_STATUS.UNAUTHORISED
            });

          case 9:
            if (!(res.status !== 200)) {
              _context3.next = 11;
              break;
            }

            return _context3.abrupt("return", {
              status: COLA_STATUS.ERROR
            });

          case 11:
            _context3.next = 13;
            return res.json();

          case 13:
            body = _context3.sent;
            return _context3.abrupt("return", {
              status: COLA_STATUS.OK,
              clientApplication: body
            });

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getClientApplication.apply(this, arguments);
}

function getClientLatest(_x7, _x8) {
  return _getClientLatest.apply(this, arguments);
}

function _getClientLatest() {
  _getClientLatest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(webapiUrl, headers) {
    var uri, overrideHeaders, res, body;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            uri = "".concat(webapiUrl, "/webapi/client/loans/latest-all-statuses");
            overrideHeaders = _typeof(headers[uri]) === 'object' ? headers[uri] : {};
            _context4.next = 4;
            return fetch(uri, {
              method: 'GET',
              credentials: 'same-origin',
              headers: _objectSpread2({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, overrideHeaders)
            });

          case 4:
            res = _context4.sent;

            if (!(res.status === 401)) {
              _context4.next = 9;
              break;
            }

            return _context4.abrupt("return", {
              status: COLA_STATUS.UNAUTHORISED
            });

          case 9:
            if (!(res.status !== 200)) {
              _context4.next = 11;
              break;
            }

            return _context4.abrupt("return", {
              status: COLA_STATUS.ERROR
            });

          case 11:
            _context4.next = 13;
            return res.json();

          case 13:
            body = _context4.sent;
            return _context4.abrupt("return", {
              status: COLA_STATUS.OK,
              clientLoanLatest: body
            });

          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getClientLatest.apply(this, arguments);
}

function getClientLatestLoanPaymentZp(_x9, _x10) {
  return _getClientLatestLoanPaymentZp.apply(this, arguments);
}

function _getClientLatestLoanPaymentZp() {
  _getClientLatestLoanPaymentZp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(webapiUrl, headers) {
    var uri, overrideHeaders, res, body;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            uri = "".concat(webapiUrl, "/webapi/client/loans/latest/payments/latest");
            overrideHeaders = _typeof(headers[uri]) === 'object' ? headers[uri] : {};
            _context5.next = 4;
            return fetch(uri, {
              method: 'GET',
              credentials: 'same-origin',
              headers: _objectSpread2({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, overrideHeaders)
            });

          case 4:
            res = _context5.sent;

            if (!(res.status === 401)) {
              _context5.next = 9;
              break;
            }

            return _context5.abrupt("return", {
              status: COLA_STATUS.UNAUTHORISED
            });

          case 9:
            if (!(res.status !== 200)) {
              _context5.next = 11;
              break;
            }

            return _context5.abrupt("return", {
              status: COLA_STATUS.ERROR
            });

          case 11:
            _context5.next = 13;
            return res.json();

          case 13:
            body = _context5.sent;
            return _context5.abrupt("return", {
              status: COLA_STATUS.OK,
              latestLoanPayment: body
            });

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getClientLatestLoanPaymentZp.apply(this, arguments);
}

function getClientLatestLoanPayment(_x11, _x12) {
  return _getClientLatestLoanPayment.apply(this, arguments);
}

function _getClientLatestLoanPayment() {
  _getClientLatestLoanPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(webapiUrl, headers) {
    var uri, overrideHeaders, res, body;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            uri = "".concat(webapiUrl, "/webapi/client/loans/latest-all-statuses/payments/latest");
            overrideHeaders = _typeof(headers[uri]) === 'object' ? headers[uri] : {};
            _context6.next = 4;
            return fetch(uri, {
              method: 'GET',
              credentials: 'same-origin',
              headers: _objectSpread2({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, overrideHeaders)
            });

          case 4:
            res = _context6.sent;

            if (!(res.status === 401)) {
              _context6.next = 9;
              break;
            }

            return _context6.abrupt("return", {
              status: COLA_STATUS.UNAUTHORISED
            });

          case 9:
            if (!(res.status !== 200)) {
              _context6.next = 11;
              break;
            }

            return _context6.abrupt("return", {
              status: COLA_STATUS.ERROR
            });

          case 11:
            _context6.next = 13;
            return res.json();

          case 13:
            body = _context6.sent;
            return _context6.abrupt("return", {
              status: COLA_STATUS.OK,
              latestLoanPayment: body
            });

          case 15:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getClientLatestLoanPayment.apply(this, arguments);
}

function getDiscounts(_x13, _x14) {
  return _getDiscounts.apply(this, arguments);
}

function _getDiscounts() {
  _getDiscounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(webapiUrl, headers) {
    var uri, overrideHeaders, res, body;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            uri = "".concat(webapiUrl, "/webapi/client/discounts/available");
            overrideHeaders = _typeof(headers[uri]) === 'object' ? headers[uri] : {};
            _context7.next = 4;
            return fetch(uri, {
              method: 'GET',
              credentials: 'same-origin',
              headers: _objectSpread2({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, overrideHeaders)
            });

          case 4:
            res = _context7.sent;

            if (!(res.status === 401)) {
              _context7.next = 9;
              break;
            }

            return _context7.abrupt("return", {
              status: COLA_STATUS.UNAUTHORISED
            });

          case 9:
            if (!(res.status !== 200)) {
              _context7.next = 11;
              break;
            }

            return _context7.abrupt("return", {
              status: COLA_STATUS.ERROR
            });

          case 11:
            _context7.next = 13;
            return res.json();

          case 13:
            body = _context7.sent;
            return _context7.abrupt("return", {
              status: COLA_STATUS.OK,
              discounts: body
            });

          case 15:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getDiscounts.apply(this, arguments);
}

function getClientSettings(_x15, _x16) {
  return _getClientSettings.apply(this, arguments);
}

function _getClientSettings() {
  _getClientSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(webapiUrl, headers) {
    var uri, overrideHeaders, res, body;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            uri = "".concat(webapiUrl, "/webapi/client/settings");
            overrideHeaders = _typeof(headers[uri]) === 'object' ? headers[uri] : {};
            _context8.next = 4;
            return fetch(uri, {
              method: 'GET',
              credentials: 'same-origin',
              headers: _objectSpread2({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, overrideHeaders)
            });

          case 4:
            res = _context8.sent;

            if (!(res.status === 401)) {
              _context8.next = 9;
              break;
            }

            return _context8.abrupt("return", {
              status: COLA_STATUS.UNAUTHORISED
            });

          case 9:
            if (!(res.status !== 200)) {
              _context8.next = 11;
              break;
            }

            return _context8.abrupt("return", {
              status: COLA_STATUS.ERROR
            });

          case 11:
            _context8.next = 13;
            return res.json();

          case 13:
            body = _context8.sent;
            return _context8.abrupt("return", {
              status: COLA_STATUS.OK,
              clientSettings: body
            });

          case 15:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getClientSettings.apply(this, arguments);
}

function getClientConsents(_x17, _x18) {
  return _getClientConsents.apply(this, arguments);
}

function _getClientConsents() {
  _getClientConsents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(webapiUrl, headers) {
    var uri, overrideHeaders, res, body;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            uri = "".concat(webapiUrl, "/webapi/client/consents");
            overrideHeaders = _typeof(headers[uri]) === 'object' ? headers[uri] : {};
            _context9.next = 4;
            return fetch(uri, {
              method: 'GET',
              credentials: 'same-origin',
              headers: _objectSpread2({
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, overrideHeaders)
            });

          case 4:
            res = _context9.sent;

            if (!(res.status === 401)) {
              _context9.next = 9;
              break;
            }

            return _context9.abrupt("return", {
              status: COLA_STATUS.UNAUTHORISED
            });

          case 9:
            if (!(res.status !== 200)) {
              _context9.next = 11;
              break;
            }

            return _context9.abrupt("return", {
              status: COLA_STATUS.ERROR
            });

          case 11:
            _context9.next = 13;
            return res.json();

          case 13:
            body = _context9.sent;
            return _context9.abrupt("return", {
              status: COLA_STATUS.OK,
              clientConsents: body
            });

          case 15:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _getClientConsents.apply(this, arguments);
}

export { getLatestLoan, getClient, getClientApplication, getClientLatestLoanPayment, getDiscounts, getClientSettings, getClientLatest, getClientLatestLoanPaymentZp, getClientConsents };